import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=e77963cc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=e77963cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77963cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e77963cc')) {
      api.createRecord('e77963cc', component.options)
    } else {
      api.reload('e77963cc', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=e77963cc&scoped=true&", function () {
      api.rerender('e77963cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EutfZZV2ZFlk/JS/comp/PopupDialog.vue"
export default component.exports